export default "__VITE_ASSET__XGJAWwUN__"